import React from 'react'
import { colors } from '../consts'
import { logEvent } from '../../Utils'
import { Favorite } from '../Favorite'
import { HeadingCon } from './styles'
import { Lk } from '../Links/Lk'

type HeadingProps = {
  teamColor?: string
  headingColor?: 'light' | 'dark'
  headingText?: string
  linkText?: string
  linkUrl?: string
  lowMargin?: boolean
  favorite?: boolean
  favName?: string
  favType?: string
  bottomBorder?: boolean
  capitalize?: boolean
}

export const SectionHeading: React.FC<React.PropsWithChildren<HeadingProps>> = ({
  headingText,
  headingColor,
  teamColor,
  linkText,
  linkUrl,
  children,
  lowMargin,
  favorite,
  favName,
  favType,
  bottomBorder = false,
  capitalize = false
}) => {
  const log = (event: string) => {
    logEvent(event, {
      linkText,
      link: linkUrl,
    })
  }
  return (
    <HeadingCon
      teamColor={teamColor || colors.gray.gray90}
      marginBottom={lowMargin ? 0 : 2}
      headingColor={headingColor}
      bottomBorder={bottomBorder}
      capitalize={capitalize}
    >
      <div className="headlineTextContainer">
        <div className="innerTextContainer">
          <div className="headline">
            {headingText && <strong>{headingText}</strong>}
            {children}
          </div>
          {favorite && (
            <Favorite className="favMargin" name={favName!} favType={favType!} />
          )}
        </div>
        <div className="headlineDivider"></div>
      </div>
      <div className="headlineTextContainer">
        <Lk
          classNameObj="viewMoreLink"
          link={linkUrl ?? ''}
          onClick={() => log('section_sublink_click')}
          alt={linkText ?? `${headingText} sublink`}
        >
          {linkText}
        </Lk>
      </div>
    </HeadingCon>
  )
}
